module.exports = __webpack_public_path__ + "img/c5b2e7f.jpg";